export namespace nsObjectUpload {
    export enum Step {
        Init,
        FormUpload,
        ProcessUpload,
        FormTransform,
        ProcessTransform,
        Success,
        Error,
    }

    export enum AssignMode {
        Dynamic, // CSV
        Static, // text field
    }
}
